import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DataService} from '../../services/data.service';
import {Router} from '@angular/router';
import { Subscription} from 'rxjs';
interface UserData {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-fraud-report-data',
  templateUrl: './fraud-report-data.component.html',
  styleUrls: ['./fraud-report-data.component.scss']
})
export class FraudReportDataComponent implements OnInit, OnDestroy {
  stateValues: any;
  staticData = ['14894620', '8237560'];
  observable: Subscription;
  selectedValue: any;
  fraudDetected: any;
  fraudAmount: any;
  userData: UserData[] = [
    {value: '1', viewValue: '521694'}, {value: '2', viewValue: '215534'},
    {value: '3', viewValue: '569714'}, {value: '4', viewValue: '648852'},
    {value: '5', viewValue: '740384'}, {value: '6', viewValue: '193442'},
    {value: '7', viewValue: '182953'}, {value: '8', viewValue: '630226'},
    {value: '9', viewValue: '924318'}, {value: '10', viewValue: '180286'}
  ];
  constructor(private http: HttpClient, private dataService: DataService, private router: Router, private zone: NgZone) {
    this.selectedValue = '1';
  }
  ngOnInit() {
    this.sendData();
    this.observable = this.dataService.fraudmessage.subscribe(data => {
        this.totalFraudData(data);
      });
    }
  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
        this.observable.unsubscribe();
    });
  }
  totalFraudData(data) {
    this.stateValues = data['value'];
    this.fraudAmount = 0;
    this.fraudAmount = this.staticData[this.stateValues];
    // this.http.get('../assets/insurance-analytics.json')
    //   .subscribe((res: any[]) => {
    //     const datasize = res;
    //     for (let i = 0; i < datasize.length; i++) {
    //       if (res[i]['prediction'] === 'N' &&  res[i]['fraud_reported']) {
    //         this.fraudAmount = 14894620;
    //         this.dataCsv.push(res[i]['incident_date']);
    //       }
    //     }
    //   });
  }

  goBack() {
    this.router.navigate(['../dashboard']);
  }
  sendData() {
    this.dataService.selectedDropValue.emit({value: this.selectedValue});
  }
}
